export default "__VITE_ASSET__BMl9$8KX__"